export default "<span class=\"info\">\r\n  {{data}}\r\n</span>\r\n"